import log from 'loglevel';
import { TriggerManager } from '../trigger-manager/trigger-manager';

interface IdentifyEventData {
  userId?: string;
  traits?: {
    [key: string]: string
  },
  type: 'identify' // required by current tracking API
}

/**
 * Will trigger a call to the tracking API to identify the user by the provided value and possibly updates their the global user id.
 * @param argument either a string which will be the externalId or an object with a single key value to be used as identifier.
 */
export default function(argument: string| number | {[key: string]: string}, argument2?: {[key: string]: string}): Promise<unknown> | void {
  if (!argument) {
    log.error('identify trigger: Must provide an argument.');
    return;
  }

  const payload: IdentifyEventData = {type: 'identify'};
  if (typeof argument === 'string') {
    payload.userId = argument;
  } else if (typeof argument === 'number') {
    payload.userId = argument.toString();
  } else if (Object.keys(argument).length) {
    payload.traits = argument;
  } else {
    log.error(`identify trigger: Argument of type ${typeof argument} not allowed.`);
    return;
  }
  // allow to add traits as a second argument
  if (argument2 && Object.keys(argument2).length) {
    payload.traits = Object.assign(argument2, payload.traits);
  }
  return TriggerManager.eventRequest<IdentifyEventData>('identify', payload);
}
